import React, { useState, useEffect } from "react";
import { Card, Row, Col, Tag, Spin, Table } from "antd";
import { getAllLeads } from "@api/user/superAdmin";

const LeadsList = () => {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchLeads();
  }, []);

  // Handle fetch leads
  const fetchLeads = () => {
    setLoading(true);
    getAllLeads()
      .then((res) => {
        setLoading(false);
        setLeads(res.data);
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
      });
  };

  // Define the columns for the table
  const columns = [
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Country",
      dataIndex: ["meta", "country_name"],
      key: "country",
      render: (country) => <Tag color="blue">{country}</Tag>,
    },
    {
      title: "State",
      dataIndex: ["meta", "state"],
      key: "state",
    },
    {
      title: "City",
      dataIndex: ["meta", "city"],
      key: "city",
      render: (city) => <Tag color="blue">{city}</Tag>,
    },
    {
      title: "Visit Date",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (date) => date.split("T")[0],
    },
    {
      title: "Country Code",
      dataIndex: ["meta", "country_code"],
      key: "countryCode",
    },
    {
      title: "IP",
      dataIndex: ["meta", "IPv4"],
      key: "IPv4",
      render: (ip) => <Tag color="red">{ip}</Tag>,
    },
  ];

  return (
    <>
      <Card style={{ borderRadius: "0", height: "100vh" }}>
        <Row>
          <Col span={24}>
            <Row justify="space-between">
              <h3 className="hp-mb-16">All Leads</h3>
            </Row>

            {/* All leads table */}
            {loading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "calc(80vh - 50px)",
                }}
              >
                <Spin />
              </div>
            ) : (
              <Table
                columns={columns}
                dataSource={leads}
                rowKey={(record) => record._id}
              />
            )}
          </Col>
        </Row>
      </Card>
    </>
  );
};

export default LeadsList;
